import React from 'react';
import { EyeIcon, EditIcon, TrashIcon, CheckIcon, GlobeIcon } from 'lucide-react';
export function CurrencyList({
  currencies,
  onSelectCurrency,
  onDeleteCurrency,
  locale
}) {
  return <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-17073">
      {currencies.length === 0 ? <div className="px-4 py-5 sm:p-6 text-center text-gray-500" data-id="element-17074">
          No currencies found. Add a new currency to get started.
        </div> : <table className="min-w-full divide-y divide-gray-200" data-id="element-17075">
          <thead className="bg-gray-50" data-id="element-17076">
            <tr data-id="element-17077">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17078">
                Code
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17079">
                Name
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17080">
                Symbol
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17081">
                Countries
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17082">
                Status
              </th>
              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17083">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-17084">
            {currencies.map(currency => <tr key={currency.currencyId} onClick={() => onSelectCurrency(currency)} className="hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-17085">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17086">
                  <div className="flex items-center" data-id="element-17087">
                    <div className="text-sm font-medium text-indigo-600" data-id="element-17088">
                      {currency.code}
                    </div>
                    <span className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-17089">
                      {currency.numericCode}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17090">
                  <div className="text-sm text-gray-900" data-id="element-17091">{currency.name}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17092">
                  <div className="text-sm text-gray-900" data-id="element-17093">{currency.symbol}</div>
                </td>
                <td className="px-6 py-4" data-id="element-17094">
                  <div className="text-sm text-gray-900 flex items-center" data-id="element-17095">
                    <GlobeIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-17096" />
                    <span data-id="element-17097">
                      {currency.countries.length > 2 ? `${currency.countries[0]}, ${currency.countries[1]} +${currency.countries.length - 2} more` : currency.countries.join(', ')}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17098">
                  {currency.isDefault ? <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-17099">
                      <CheckIcon className="h-4 w-4 mr-1" data-id="element-17100" />
                      Default
                    </span> : <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-17101">
                      Active
                    </span>}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-17102">
                  <button onClick={e => {
              e.stopPropagation();
              onSelectCurrency(currency);
            }} className="text-green-600 hover:text-green-900 mr-3" title="View currency" data-id="element-17103">
                    <EyeIcon className="h-4 w-4" data-id="element-17104" />
                    <span className="sr-only" data-id="element-17105">View</span>
                  </button>
                  <button onClick={e => {
              e.stopPropagation();
              onSelectCurrency(currency);
            }} className="text-indigo-600 hover:text-indigo-900 mr-3" title="Edit currency" data-id="element-17106">
                    <EditIcon className="h-4 w-4" data-id="element-17107" />
                    <span className="sr-only" data-id="element-17108">Edit</span>
                  </button>
                  <button onClick={e => {
              e.stopPropagation();
              onDeleteCurrency(currency);
            }} className="text-red-600 hover:text-red-900 disabled:opacity-50 disabled:cursor-not-allowed" disabled={currency.isDefault} title={currency.isDefault ? 'Cannot delete default currency' : 'Delete currency'} data-id="element-17109">
                    <TrashIcon className="h-4 w-4" data-id="element-17110" />
                    <span className="sr-only" data-id="element-17111">Delete</span>
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>}
    </div>;
}